import { useState, useEffect } from "react";
import { fetchWithCache } from "../utils/apiCache";

export function useSocialLinks() {
    const [socialLinks, setSocialLinks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const fetchSocialLinks = async () => {
            try {
                setLoading(true);
                const url = `${process.env.REACT_APP_BACKEND_URL}/social-links?visible_only=true`;
                const result = await fetchWithCache(url);
                
                if (result.status === 404) {
                    setSocialLinks([]);
                } else {
                    const data = result.data;
                    // Ordenar por el campo 'order'
                    const sortedData = Array.isArray(data) ? data.sort((a, b) => a.order - b.order) : [];
                    setSocialLinks(sortedData);
                }
                setError(null);
            } catch (err) {
                console.error("Error fetching social links:", err);
                setError(err.message);
                setSocialLinks([]);
            } finally {
                setLoading(false);
            }
        };

        fetchSocialLinks();
    }, []);

    return {
        socialLinks,
        loading,
        error,
        hasNoData: !loading && socialLinks.length === 0,
    };
}
